import { render, staticRenderFns } from "./DeliveringSoon.vue?vue&type=template&id=7d884a4c&"
import script from "./DeliveringSoon.vue?vue&type=script&lang=js&"
export * from "./DeliveringSoon.vue?vue&type=script&lang=js&"
import style0 from "./DeliveringSoon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports